import { Skeleton } from '@mui/material';
import styles from './activitiesPoints.module.css';

const ActivitiesPoints = ({
  history,
  title,
  linkTitle,
  children,
  pathName,
  loading,
  className = '',
  chevronColor = 'var(--color-primary)',
}) => {
  const SkeletonActivity = () => (
    <div className='row p-2'>
      <div className='col-3 pr-1'>
        <Skeleton
          variant='rectangular'
          sx={{ bgcolor: '#2a2d2d', width: '100%', borderRadius: '.4rem', height: 48 }}
        />
      </div>
      <div className='col-5 px-1'>
        <Skeleton
          variant='rectangular'
          sx={{ bgcolor: '#2a2d2d', width: '100%', borderRadius: '.4rem', height: 48 }}
        />
      </div>
      <div className='col-4 pl-1'>
        <Skeleton
          variant='rectangular'
          sx={{ bgcolor: '#2a2d2d', width: '100%', borderRadius: '.4rem', height: 48 }}
        />
      </div>
    </div>
  );

  const skeletonActivities = Array.from({ length: 5 }, (_, index) => (
    <SkeletonActivity key={index} delay={index * 100} />
  ));

  return (
    <div className={`${styles.container} ${className}`}>
      {title && (
        <div className='mb-3 pl-1'>
          <div className='font-medium'>{title}</div>
        </div>
      )}

      <div>
        {loading ? (
          <div>{skeletonActivities}</div>
        ) : (
          <>
            <div>{children}</div>

            {linkTitle && pathName && (
              <div className={styles.viewAllButton} onClick={() => history.push(pathName)}>
                <span className={`${styles.linkText} fw-semibold font-small `}>{linkTitle}</span>
                <svg
                  className={styles.chevron}
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke={chevronColor}
                  strokeWidth='2.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <polyline points='9 18 15 12 9 6'></polyline>
                </svg>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ActivitiesPoints;
